let warned = false;

/**
 * Etiquetas que tiram o contato da cadência de follow-up.
 *
 * **O Ruby é a fonte.** A lista vem de
 * `FollowUpCadences::EligibilityService::EXCLUSION_LABELS`, injetada em
 * `window.globalConfig` pelo `DashboardController#app_config`.
 *
 * Antes existiam DUAS cópias — uma no Ruby e outra escrita à mão aqui no
 * front — de um contrato que decide se uma pessoa recebe mensagem. E o
 * comentário do próprio `EligibilityService` registra que já houve bug em
 * produção por o código conhecer só uma das duas variantes de escrita
 * (`excluido-` vs `excluir-`). Duas cópias × duas variantes = quatro lugares
 * para divergir.
 *
 * Sem a config (bundle antigo, teste sem setup), devolve lista vazia **de
 * propósito**: o backend continua sendo a autoridade e já filtra. O pior caso
 * vira "a conversa some da tela só no próximo refresh" — o comportamento
 * anterior a 2026-07-23 — em vez de carregarmos aqui uma cópia que pode estar
 * velha e discordar do servidor.
 *
 * @returns {string[]}
 */
export const followUpExclusionLabels = () => {
  const fromConfig = window.globalConfig?.FOLLOW_UP_EXCLUSION_LABELS;

  if (Array.isArray(fromConfig)) return fromConfig;

  if (!warned) {
    warned = true;
    // eslint-disable-next-line no-console
    console.warn(
      '[follow-up] FOLLOW_UP_EXCLUSION_LABELS ausente em window.globalConfig — ' +
        'a lista de conversas não vai esconder sozinha quem foi excluído da ' +
        'cadência. O backend segue filtrando.'
    );
  }

  return [];
};
